import type {
  ContactAttributes,
  ContactProfile,
  ContactSummary,
  ResolvedContactIdentity,
} from '@chatbot/shared-types';
import { request } from './peticion.js';

export const contactsApi = {
  list: (params: {
    tenantId: string;
    channel?: 'telegram' | 'whatsapp';
    search?: string;
    limit?: number;
    cursor?: string;
  }) => {
    const q = new URLSearchParams();
    q.set('tenantId', params.tenantId);
    if (params.channel) q.set('channel', params.channel);
    if (params.search) q.set('search', params.search);
    if (params.limit) q.set('limit', String(params.limit));
    if (params.cursor) q.set('cursor', params.cursor);
    return request<{ items: ContactSummary[]; cursor: string | null }>(
      `/admin/contacts?${q.toString()}`,
    );
  },
  get: (tenantId: string, userId: string) => {
    return request<ContactProfile>(`/admin/contacts/${tenantId}/${userId}`);
  },
  /**
   * Guarda la edición manual. Un campo en cadena vacía BORRA el override y
   * hace reaparecer el valor del ERP o del canal.
   */
  update: (
    tenantId: string,
    userId: string,
    body: { attributes: ContactAttributes; notes?: string | null },
  ) => {
    return request<{
      identity: ResolvedContactIdentity;
      notes: string | null;
      updatedAt: string;
    }>(`/admin/contacts/${tenantId}/${userId}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
    });
  },
};
